import { colorGreyD4 } from "../../styles/manualVars";
import Svg from "./Svg";

const Clock = () => (
  <Svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 0C3.13435 0 0 3.13435 0 7C0 10.8656 3.13435 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13435 10.8656 0 7 0ZM7 13.1765C3.59471 13.1765 0.823529 10.4053 0.823529 7C0.823529 3.59471 3.59471 0.823529 7 0.823529C10.4053 0.823529 13.1765 3.59471 13.1765 7C13.1765 10.4053 10.4053 13.1765 7 13.1765ZM7.41177 2.88235V6.77929L9.69953 8.30447C9.88894 8.43047 9.94 8.68659 9.814 8.87518C9.73412 8.99459 9.604 9.05882 9.47059 9.05882C9.39153 9.05882 9.31247 9.03659 9.24247 8.98965L6.77188 7.34259C6.65659 7.266 6.58824 7.13753 6.58824 7V2.88235C6.58824 2.65506 6.77271 2.47059 7 2.47059C7.22729 2.47059 7.41177 2.65506 7.41177 2.88235Z"
      fill={colorGreyD4}
    />
  </Svg>
);

export default Clock;
